
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexTozokn49O_45s1U_45YJwq1Dk_45SUjBdl9__4501Q7DRPURsAcMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/index.vue?macro=true";
import { default as logindUKPundfarb2m7j7g2SyYsjmDd7mPz3nDJZS7GR5cckMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/login.vue?macro=true";
import { default as verifyG6Fi7lDcZa_45RSstBtZSV2pYj78iFzZNe6tbxBG_45AVbUMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/verify.vue?macro=true";
import { default as sitemapiPfiDN3lJDuHd37JE7weeC4KkIumszeukpNedjVZp24Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/sitemap.vue?macro=true";
import { default as about_45uslUUCE0AlptaOf7l9DWFyjZChEEwYCwPryB7qe7DWTWgMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/about-us.vue?macro=true";
import { default as registerafgWKJKv_k0Rn5yvsEvYPosXS9XjAOOdvG_45q9jVpvdAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/register.vue?macro=true";
import { default as complaintsdnpVII04czJDmbENOEM_5QQ5EEfwqi6wye5KClCkwSoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/complaints.vue?macro=true";
import { default as contact_45usNZokkqKO4LFzfgYB_45IwxcFbWkMbfpqSJVi9wQrHsN2AMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/contact-us.vue?macro=true";
import { default as indexmNuEh_45k4bZIAsCuqeMIbRDJcLAICHrH8j0uLQa4V_457UMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/media/index.vue?macro=true";
import { default as index_4_45U09_453VXm4ldkRxlEeEyW_y3iFYsEq7uAJ_45DGwYFEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/index.vue?macro=true";
import { default as _91slug_93STk5yaa1lyohdZu5OCPuopdCV7wqpPhha3powMnZ02wMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/media/[slug].vue?macro=true";
import { default as partnershipsTHKyy1E4raXBSqHRW68whaWy8wwfnD9VfrSXex9dzDsMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/partnerships.vue?macro=true";
import { default as terms_45of_45useLgbCL0nY9P2KDQ7gcps0P888msa2w7148LphEpvuBD8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/terms-of-use.vue?macro=true";
import { default as indexON0OfTdSbsVvpg9ZRBM9cI50L0U98FvkVA2OjJlZgpoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/careers/index.vue?macro=true";
import { default as privacy_45policyTvS9ybmBu7FxxKOkSSS07xFQFa97iFQkLj8h8mNK_z4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/privacy-policy.vue?macro=true";
import { default as reset_45passwordZ3iBi5EEKXiI5NpfKIXoBn0eQ81NjVLnK3jPftS_45Ht8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/reset-password.vue?macro=true";
import { default as indexOzL7lFxKkcldTVEefM8_45xKp7k_45tq0KBv1MvIcCo9cjMMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-loans/index.vue?macro=true";
import { default as indexh6KekQJ3V0_45WbQAa_45L2oZWCbZhWnTKTWFsH_45HbC_5MoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/index.vue?macro=true";
import { default as legalDbI0oo9A9UoJzpP5fRW3K301DqQktdBZgjVa__AwClEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/legal.vue?macro=true";
import { default as forgot_45passwordAQxLCt6IuIFwmXHk4PPh7Osgyp_nGxVbdAG7dww8H9AMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/forgot-password.vue?macro=true";
import { default as errorT79dujHdzOYZp2YisEGpD3_45ZyDUJnZgzsE25xY_TS94Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/cdr/error.vue?macro=true";
import { default as indexovFhTKUgGKbnUHWmF6Prf5hxa1ENKpkaKKTjSUGQx_UMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/index.vue?macro=true";
import { default as _91slug_93TkLf6_45MTxiC_45Jr_45xPjpYTaQRrF7rbEm1fUrFZujz_45d4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/[slug].vue?macro=true";
import { default as guidesmB86WFIky8tzgFcaDzAnNaEwloz3dA6ETf5_45OGs9Bs8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/guides.vue?macro=true";
import { default as collection_45noticewsTMAplnXZH6zIdhulkxcZ8V1MtWa03CZND30CgnhDwMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/collection-notice.vue?macro=true";
import { default as indexFxT2BF5dKsAIEV2FdOTCQaWTaoQ4YTO6RdSJTVyOMREMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/index.vue?macro=true";
import { default as set_45passwordxih2xVT7zcfrEvNPdGb4vdKDkRMAHEtxcUcSCo6q0cgMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/guest/set-password.vue?macro=true";
import { default as welcome_45backgnNQPr4N2xTAfg0XFcXkiWf8KNrIwNsnAgVjsdpQUQ8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/guest/welcome-back.vue?macro=true";
import { default as merge2mqKL159gb9ivNn00Ren707HqF0OfCRCu84aVFSRjyQMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/authorization/merge.vue?macro=true";
import { default as indexRQRKpinn2wu8yg6Zju7NZYQqjf3j3jVvarGbnyEghNMMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/index.vue?macro=true";
import { default as _91slug_93fnJ9MoP3U9P6EnRuVqC3KrksaaIa_45GlhaNqy6aFb1rYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/[slug].vue?macro=true";
import { default as post_45sale_45thank_45youxTw4Jq5VsmaDydN1HUPtn07FwYgG13HMfUa_45iqy4NqUMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/post-sale-thank-you.vue?macro=true";
import { default as thank_45you7Q9bsmAuH_45ACdc3hck2tXB_7mXAaJiqnLvswla48m3MMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/cdr/thank-you.vue?macro=true";
import { default as indexmmFubAr4qoXed06p0PC2mxKP2XIs0t4cuRi6N9JtNXEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/index.vue?macro=true";
import { default as indexMxcRqeFUyXQHgkZPhnyPEUhZgLvIMUMDDk2Fs9ABy20Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/index.vue?macro=true";
import { default as _91slug_937XQnR3liX2iJo4mS_5I2IdjXWnlhMCGTL19h1mzztTAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/preview/media/[slug].vue?macro=true";
import { default as indexYDRR93fDf_ylwka5YyZ3IC6q2wD0qHJhCuBDNA_UMDUMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/perks/index.vue?macro=true";
import { default as indexDIaV1oi63wNLiujGfVjQGL7ROzwKS3vSjPDjbgu8BCsMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/index.vue?macro=true";
import { default as _91author_93gJFtvyO6_Sm3AGrtZgM8ZnC8S_45FlOTHZGr5grqZGjnAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/media/author/[author].vue?macro=true";
import { default as callback8lXaaPpcqFxvb3cOrWKv50oE0wd6fuesnpLZXHiHSS0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/authorization/callback.vue?macro=true";
import { default as buyer_45protection_45claimVD1CoUz_45RsUl7ximlhAEdaho_45dU0cyre8U35nD0dQy0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/buyer-protection-claim.vue?macro=true";
import { default as indexkOyboaj6z_45Y45PHR1jLlGjIeYL07xvkXEquP2dkJPSYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/quotes/index.vue?macro=true";
import { default as thank_45youqKJySxiaCSEprKYnaWugaz9HoGXVDzPftXXsQpmKqcsMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/quote/thank-you.vue?macro=true";
import { default as errorpya_xH8faXKBLmnjROXUWP8xlT6NnddxUOx8sqKYOBoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/error.vue?macro=true";
import { default as indexeiW4gMU3BVEx1wZFvdW1oSyux6siA1Mx8j_45vS_45udhO4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/index.vue?macro=true";
import { default as index5XgyXGIyDLnsfBmlD790SXvjsEA0aGUE8o5q5O_45oD44Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/rewards/index.vue?macro=true";
import { default as errorKipbA6bbj9Fm4lYKQJ3z1SLqK4Qy5H_45RWA0OxoW1j1oMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/application/error.vue?macro=true";
import { default as _91step_93JmcNIMOFK6ZMoDptvsu_6_45nsvhpGmoxFMxoyZDJFoL8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/quote/form/[step].vue?macro=true";
import { default as detailsDqvVYTNaK3ItjI8nwGlaqjoj428iRiuUiQRYBKMsPToMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/quote/form/details.vue?macro=true";
import { default as interest_45rateskC0w1be_45imrFVvtUN7KXCbHG61sSRtwnSfalImn6k_45QMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/interest-rates.vue?macro=true";
import { default as _91slug_93c2UX1EzdsrD6qzlG6YhmE9uCKFlvomDcyeEmajIVDawMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/preview/[vertical]/[slug].vue?macro=true";
import { default as indexm93bcRaezZq_45AYGL06fl5tTB2Xlt55G3yJxes3sQaUUMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/companies/index.vue?macro=true";
import { default as account_45settings_45FMrb0IrOmr4Na5kwT8GfVgKU7Nc_45kSdTp_45QFVREzzQMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/account-settings.vue?macro=true";
import { default as indexbX_FGajkOyvheOZx1nTcvy_lka6UTudYpO7K5qN55eEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/onboarding/index.vue?macro=true";
import { default as live_45chatsFe_JF7LbsPYvzxdd49YdLyaBcDbaUPSDL9Uc51DUroMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/live-chat.vue?macro=true";
import { default as post_45salePM0v__5RGkEyVSqSbLaj3SKW6LieDcH8iLJ5wd9uUdwMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/post-sale.vue?macro=true";
import { default as thank_45you1bqm8hem2uyibHpi_SQ6twXkHdKN1Q6iuVzKP2vYHUcMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/quote/thank-you.vue?macro=true";
import { default as comprehensiveTef3PzXsvAILDFMPd8hVqKXwLUlzbpsQycQF0u_45vgV8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/comprehensive.vue?macro=true";
import { default as _91slug_931Omrp4T1E8_45A21mOGfVQb2ZpdVh3xKvWNnrisN0AYOcMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/preview/[slug].vue?macro=true";
import { default as addZZ2_45RsQY1_45K3vqP0XJW7JXBYn2Z6iFk5zSN6Cf9wAwwMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/partners/add.vue?macro=true";
import { default as index_45MkZ6C_451hFL5UGQlxXGhBNBB5cKvIkMJ86I0TBpCGLkMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue?macro=true";
import { default as _91response_93_45u_45x8iNTzoBrsFQlb3kTI9NG250b_45fVH8gFg8JwsjssMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue?macro=true";
import { default as schedule_45callbackD_hAQ_45Dm663QmWkGUh8AG8inuwfXDwTvVDXGqK96QXQMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/schedule-callback.vue?macro=true";
import { default as _91slug_93lO0X4PHaX72UD4BZOD963NDuI4ygr26TWoGuDy2_omIMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue?macro=true";
import { default as thank_45youfvtXZng_7WUL6Fw_BBT0LG_60A4s5ZAJgG3Xxp11I60Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/application/thank-you.vue?macro=true";
import { default as live_45chat_45blMdRvkMYXK323W1vTswFJ1HvoF_45dpuOC41XvGUlQ_EoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/live-chat-b.vue?macro=true";
import { default as indexwdWodjfZ9JhFXq1nHOc0S31Rt4mU4E_DyTBSFHZu9osMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/calculators/index.vue?macro=true";
import { default as _91step_93oq0MffuTn1hVnsf7towFiiryxbEWUHygMkGEkpkLEZEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93YoAfjoJIYrQV_45Yi6u59NcTrCWyfUY5JJIe25SMJ0Z7gMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue?macro=true";
import { default as indexv3XewEXSRD3lOF8yclXzV5PmqyTvakxlNgAZmMCVxSEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/offers/index.vue?macro=true";
import { default as addI1Fx1_wgJO4hjq2Fp1MDF9ISd2XFQCve7Lmtu36Jt5oMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/partners/add.vue?macro=true";
import { default as _91type_93_eE5YPLaLhHAto6q7kg4cCepnsOWHr7v3KS24E9O4CsMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/calculators/[type].vue?macro=true";
import { default as detailskbPHIWhCGVvCcLrbn_feBn95CcN6dc4m_452KKAbtSBTEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/quote/form/details.vue?macro=true";
import { default as callbackdxz0ctqovM3_GWcYD8AZJUmMsVjfhfTLjmx8CX28aoQMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/callback.vue?macro=true";
import { default as digital_45eicfsrECawQxYqjHAtf4X5SKjJbZdIzMGH8afJnFH682GAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/application/digital-eic.vue?macro=true";
import { default as thank_45you1cF0QmmJPbvOfPMJh0kkvIpL99pD_mjdQczPG9zbaRkMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue?macro=true";
import { default as _91step_93okC0VMtdn6_vZxk_45usoR7xY3zAmo6aVGPS8Qkz9jBaIMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue?macro=true";
import { default as _91author_93206jOd7TeUcaUfM1Th2gdZUEj7nUD_GoVVxewxIXsyAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/author/[author].vue?macro=true";
import { default as comparisonrnXrK_454_45dr5J071oARuHBttXcsdop31Qj6WGSHU8vk8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/comparison.vue?macro=true";
import { default as step1kRL73F2Nr3MFgpLxKPX9c7HPAIAJeiNKwo6Pi6tUPrYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue?macro=true";
import { default as details9hFY22sb4FhpIiNgTN8MgzyaUjHAbRgFekKOYn0YSEIMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/quote/form/details.vue?macro=true";
import { default as resultsGY0S_45o8Hcrmz60cX_UurGNu_wxj23zT4funfc1hvTGwMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/quote/form/results.vue?macro=true";
import { default as index8xc9_HsuubHBEJloJp7a_45TU74yj1Cc1M_45_45Vdro7DpfsMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/[category]/index.vue?macro=true";
import { default as signupxLBYj1XgLteL_45lw_45Vz9mdCI5eBArksSEvZAVqvgS_45T4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/partners/signup.vue?macro=true";
import { default as thank_45youbUKhcm1Jos_45E_454OBRjmoMDCMXDevSBwr8UGrXAFniT0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue?macro=true";
import { default as _91step_93GdhmdReWr6fwjATTFURWftYje99QhGnpmRhW0pfxq5wMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/form/[step].vue?macro=true";
import { default as _91step_93FxC3h_45bw39PUHqyU46v_45_yymGpJnWa_45PVJm_45jE1fBWQMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue?macro=true";
import { default as _91slug_93ldXuVWqc4BVoo9eqBjGu6enVsyse4WK_cG9QAELvPFIMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue?macro=true";
import { default as step0jgNQixxcR_KWLuAxeFiJAmVg6_45StTHA7wFB3MkebJd4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue?macro=true";
import { default as existing_45customershdiV8DYvcNWIom_O0Ua8iu4QVdKJu8c51IZP42kkJDwMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/existing-customers.vue?macro=true";
import { default as thank_45youk11s_45VlDFCtTZaxixZghjdOHh1EgR1t2iDrLIO_VIY8Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue?macro=true";
import { default as detailsHhWWxgzUsfsjdHGqZAwpPkK_45BUpM8sLgZwHNQNX3dPkMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/form/details.vue?macro=true";
import { default as detailsKvli7EPX8q8UyGvQi7S3kC6pBCua5meVZqJz2yhap7UMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/quote/form/details.vue?macro=true";
import { default as _91step_93n4zIaBhQZhQBgCzuqNNuVsDKPcIh8SlPOsMV1kwxTicMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue?macro=true";
import { default as rebatewn0hao7UdOvp4KVTeq_45ejrKZ46sy0HQ2jwPzmBgHKVgMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue?macro=true";
import { default as _91step_93D71TdwMMpCokOzttowuEUUpXz10UGO7KlbaFy73xOzsMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/[step].vue?macro=true";
import { default as detailsEHxCkF4IJwKW64TeR4v_ecR_PArhcYWeIEIRWUhn1pAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/form/details.vue?macro=true";
import { default as step0UwvmwzovtOl5WLG2EyFGgCLgxozldkmiipdNWNUesGIMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue?macro=true";
import { default as indexuqX16TKrohKZsdCxK1kkoeLnJLowJZs8YFFe3SwRtpAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue?macro=true";
import { default as indexJE7TeombArnMR7zClqHfZDxSvJ9Ad_fDlCTXs4yImoEMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue?macro=true";
import { default as detailsvBg6XyhFsirdfBCztlG3dRZVcikVhkWP5EQC2BOmsSYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue?macro=true";
import { default as terms_45and_45conditionsG9b1xcv9Oj_45WHO_45kepRXBhhUMSC3WU_45IveQfWCNOq18Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue?macro=true";
import { default as _91location_93NN5lMYqX8M6sWVhHuanyABVHLsJSN0aK3RzceuKBBHAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/compare-by-location/[location].vue?macro=true";
import { default as indexMEN_45j7N0t_N1t8fPfPT_GXKoovm_0HbXA3HgMIa_45gc0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue?macro=true";
import { default as detailsgt_wjbdyMftU7yr_45vwus9ZutNpf9MXqk5ZNiBxsSUc0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue?macro=true";
import { default as indexQoErMMnJZAh_459YMlEFXJFdQhOfUxW2SILFKN_4Z2OUcMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue?macro=true";
import { default as success_R_45sPlLfOubVyMvCdmELIwf_y_VNm5O6vmMWW_0M5bUMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue?macro=true";
import { default as claim_45offerCb5mSsCNSyre390gWOyLWkzCfRynO43JPUsx6UensnAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue?macro=true";
import { default as lic_45detailsvKdTSs4eGpvZ5ZtgYP8ujvJll75fuNcdC1cNlId5F_45MMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue?macro=true";
import { default as _91step_93H43sj4ok9LTvBmqj2T6BCepVRpnpBE1j1Dv95TqyzH4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue?macro=true";
import { default as index4KX748o7TLx7R2KaGiPQAMo2BZNEvYPS92D_45oTYOBSoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue?macro=true";
import { default as _91slug_93fsEYrT2lDFsvFg2MYpogJ8Y2YiHd_gOFYtyNHjYPffAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue?macro=true";
import { default as indexIHltgzedyH1M_rF_45ckvnvlpn9ALVD1S8jn5dxm_bBVYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/payment/index.vue?macro=true";
import { default as _91step_93d7GFJ9DEF7SGF_smjJtzZBYBGBcmEBFMHlc4dG5KyToMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue?macro=true";
import { default as indexzu3g3njlAun4VX4Js3VgPBf6Ut4dqdUY_45HYM2F7Nul0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue?macro=true";
import { default as indexCJ78Kk8LskKvBHYDQnrLQCOM0dPzpSHnbLh4Fc3j9GgMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue?macro=true";
import { default as detailsOISoxasv5ATemP68HXvCBa_45oW_PaGJQxgI82jbP7P44Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue?macro=true";
import { default as expiredB7N6zT_xnilgxOp3s3mF907WmaNLjS72jWVWdZhxE0AMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue?macro=true";
import { default as indexavNpntc9CuaphxRnbcQ7qmV2nYBA1CytLwOC5F_45_96MMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue?macro=true";
import { default as thank_45youuehXPBZN3XUky6g5rf8aaOy_iquQuq8PKidKBZbNLEgMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue?macro=true";
import { default as detailsm4qmMunP8WtDP7EiMO1UEPcTM9q4tDLgmqSFUWt_45P_45IMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue?macro=true";
import { default as confirmationcw4Ng_tqIMY1gHl2oDHeHUj_45sRnnVozPuwhX7OBV2HwMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue?macro=true";
import { default as completion8PqaCYIlR1H_rdeehrOgWtdxRe1EzriAYbv4xaYeKLoMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue?macro=true";
import { default as quotes_45resultsKZHRnj254xQVP_45_GhsPWzA3c0MLB51o0oQZXADhc9toMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue?macro=true";
import { default as confirmationMYgur5_V7o3uaG34PqC5miQ_d3W0jpD2wkYQEIXEGb4Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue?macro=true";
import { default as _91step_932k94xRdbEdAIUKPqyNdwu8xVtcLWbriu29a5VWphDG0Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue?macro=true";
import { default as _91step_93Lw7TGAqzJE7_NSlV0KQ7_45Oy_4504PKfayxEWRGBSUla7wMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue?macro=true";
import { default as _91step_93dOf_45WngbdS2RhgRKXf1fjmZnfMVJl48Rd99PKoD6KGYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue?macro=true";
import { default as _91step_93WvnB1O4xA8Oea5wk5mfVXbEveSv_7biRLBt6oNzRE94Meta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue?macro=true";
import { default as indexNgBsfkRzBvyKcvoGyzTW1w5iKDGk4GZMn8DMGWVcs3cMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue?macro=true";
import { default as additional_45detailsgrN2PYN6LU2P6sGtg4cN63oxH0nBooCO5ohi1UZolBAMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue?macro=true";
import { default as _91step_93FvceXjKVOWouGNRpEE3j3MeKwK8XMzQsLd_45UZP2Py1kMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue?macro=true";
import { default as _91step_93mHh8S6hehg_19opnfLnx5nbLAaBAfEn5l7d70wXJ_45AUMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue?macro=true";
import { default as indexhs950PnyZQ_ydhlWhg5Ma9_45KSfNOOiypSyoYqafg0NYMeta } from "/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logindUKPundfarb2m7j7g2SyYsjmDd7mPz3nDJZS7GR5cckMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/login.vue")
  },
  {
    name: "verify",
    path: "/verify",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/verify.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/sitemap.vue")
  },
  {
    name: "about-us",
    path: "/about-us",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/about-us.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerafgWKJKv_k0Rn5yvsEvYPosXS9XjAOOdvG_45q9jVpvdAMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/register.vue")
  },
  {
    name: "complaints",
    path: "/complaints",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/complaints.vue")
  },
  {
    name: "contact-us",
    path: "/contact-us",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/contact-us.vue")
  },
  {
    name: "media",
    path: "/media",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/media/index.vue")
  },
  {
    name: "energy",
    path: "/energy",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/index.vue")
  },
  {
    name: "media-slug",
    path: "/media/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/media/[slug].vue")
  },
  {
    name: "partnerships",
    path: "/partnerships",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/partnerships.vue")
  },
  {
    name: "terms-of-use",
    path: "/terms-of-use",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/terms-of-use.vue")
  },
  {
    name: "careers",
    path: "/careers",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/careers/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/privacy-policy.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordZ3iBi5EEKXiI5NpfKIXoBn0eQ81NjVLnK3jPftS_45Ht8Meta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/reset-password.vue")
  },
  {
    name: "car-loans",
    path: "/car-loans",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-loans/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexh6KekQJ3V0_45WbQAa_45L2oZWCbZhWnTKTWFsH_45HbC_5MoMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/index.vue")
  },
  {
    name: "dashboard-legal",
    path: "/dashboard/legal",
    meta: legalDbI0oo9A9UoJzpP5fRW3K301DqQktdBZgjVa__AwClEMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/legal.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordAQxLCt6IuIFwmXHk4PPh7Osgyp_nGxVbdAG7dww8H9AMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/forgot-password.vue")
  },
  {
    name: "energy-cdr-error",
    path: "/energy/cdr/error",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/cdr/error.vue")
  },
  {
    name: "home-loans",
    path: "/home-loans",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/index.vue")
  },
  {
    name: "vertical-slug",
    path: "/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/[slug].vue")
  },
  {
    name: "vertical-guides",
    path: "/:vertical()/guides",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "collection-notice",
    path: "/collection-notice",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/collection-notice.vue")
  },
  {
    name: "credit-cards",
    path: "/credit-cards",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/index.vue")
  },
  {
    name: "guest-set-password",
    path: "/guest/set-password",
    meta: set_45passwordxih2xVT7zcfrEvNPdGb4vdKDkRMAHEtxcUcSCo6q0cgMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/guest/set-password.vue")
  },
  {
    name: "guest-welcome-back",
    path: "/guest/welcome-back",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/guest/welcome-back.vue")
  },
  {
    name: "authorization-merge",
    path: "/authorization/merge",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/authorization/merge.vue")
  },
  {
    name: "car-insurance",
    path: "/car-insurance",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/index.vue")
  },
  {
    name: "credit-cards-slug",
    path: "/credit-cards/:slug()",
    meta: _91slug_93fnJ9MoP3U9P6EnRuVqC3KrksaaIa_45GlhaNqy6aFb1rYMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/[slug].vue")
  },
  {
    name: "post-sale-thank-you",
    path: "/post-sale-thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/post-sale-thank-you.vue")
  },
  {
    name: "energy-cdr-thank-you",
    path: "/energy/cdr/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/cdr/thank-you.vue")
  },
  {
    name: "life-insurance",
    path: "/life-insurance",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/index.vue")
  },
  {
    name: "personal-loans",
    path: "/personal-loans",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/index.vue")
  },
  {
    name: "preview-media-slug",
    path: "/preview/media/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/preview/media/[slug].vue")
  },
  {
    name: "dashboard-perks",
    path: "/dashboard/perks",
    meta: indexYDRR93fDf_ylwka5YyZ3IC6q2wD0qHJhCuBDNA_UMDUMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/perks/index.vue")
  },
  {
    name: "expert-analysis",
    path: "/expert-analysis",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/index.vue")
  },
  {
    name: "media-author-author",
    path: "/media/author/:author()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/media/author/[author].vue")
  },
  {
    name: "authorization-callback",
    path: "/authorization/callback",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/authorization/callback.vue")
  },
  {
    name: "buyer-protection-claim",
    path: "/buyer-protection-claim",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/buyer-protection-claim.vue")
  },
  {
    name: "dashboard-quotes",
    path: "/dashboard/quotes",
    meta: indexkOyboaj6z_45Y45PHR1jLlGjIeYL07xvkXEquP2dkJPSYMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/quotes/index.vue")
  },
  {
    name: "energy-quote-thank-you",
    path: "/energy/quote/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/quote/thank-you.vue")
  },
  {
    name: "health-insurance-error",
    path: "/health-insurance/error",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/error.vue")
  },
  {
    name: "health-insurance",
    path: "/health-insurance",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/index.vue")
  },
  {
    name: "dashboard-rewards",
    path: "/dashboard/rewards",
    props: index5XgyXGIyDLnsfBmlD790SXvjsEA0aGUE8o5q5O_45oD44Meta?.props ?? {"verificationNeeded":true},
    meta: index5XgyXGIyDLnsfBmlD790SXvjsEA0aGUE8o5q5O_45oD44Meta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/rewards/index.vue")
  },
  {
    name: "energy-application-error",
    path: "/energy/application/error",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/application/error.vue")
  },
  {
    name: "energy-quote-form-step",
    path: "/energy/quote/form/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/quote/form/[step].vue")
  },
  {
    name: "energy-quote-form-details",
    path: "/energy/quote/form/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/quote/form/details.vue")
  },
  {
    name: "home-loans-interest-rates",
    path: "/home-loans/interest-rates",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/interest-rates.vue")
  },
  {
    name: "preview-vertical-slug",
    path: "/preview/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/preview/[vertical]/[slug].vue")
  },
  {
    name: "vertical-companies",
    path: "/:vertical()/companies",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  },
  {
    name: "dashboard-account-settings",
    path: "/dashboard/account-settings",
    meta: account_45settings_45FMrb0IrOmr4Na5kwT8GfVgKU7Nc_45kSdTp_45QFVREzzQMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/account-settings.vue")
  },
  {
    name: "dashboard-onboarding",
    path: "/dashboard/onboarding",
    meta: indexbX_FGajkOyvheOZx1nTcvy_lka6UTudYpO7K5qN55eEMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/onboarding/index.vue")
  },
  {
    name: "health-insurance-live-chat",
    path: "/health-insurance/live-chat",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/live-chat.vue")
  },
  {
    name: "health-insurance-post-sale",
    path: "/health-insurance/post-sale",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/post-sale.vue")
  },
  {
    name: "home-loans-quote-thank-you",
    path: "/home-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-comprehensive",
    path: "/car-insurance/comprehensive",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/comprehensive.vue")
  },
  {
    name: "credit-cards-preview-slug",
    path: "/credit-cards/preview/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/preview/[slug].vue")
  },
  {
    name: "life-insurance-partners-add",
    path: "/life-insurance/partners/add",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/partners/add.vue")
  },
  {
    name: schedule_45callbackD_hAQ_45Dm663QmWkGUh8AG8inuwfXDwTvVDXGqK96QXQMeta?.name,
    path: "/:vertical()/schedule-callback",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/schedule-callback.vue"),
    children: [
  {
    name: "vertical-schedule-callback",
    path: "",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/schedule-callback/index.vue")
  },
  {
    name: "vertical-schedule-callback-response",
    path: ":response()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/schedule-callback/[response].vue")
  }
]
  },
  {
    name: "credit-cards-redirect-slug",
    path: "/credit-cards/redirect/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/credit-cards/redirect/[slug].vue")
  },
  {
    name: "energy-application-thank-you",
    path: "/energy/application/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/application/thank-you.vue")
  },
  {
    name: "health-insurance-live-chat-b",
    path: "/health-insurance/live-chat-b",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/live-chat-b.vue")
  },
  {
    name: "home-loans-calculators",
    path: "/home-loans/calculators",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/calculators/index.vue")
  },
  {
    name: "home-loans-quote-form-step",
    path: "/home-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/quote/form/[step].vue")
  },
  {
    name: "car-insurance-redirect-slug",
    path: "/car-insurance/redirect/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/redirect/[slug].vue")
  },
  {
    name: "health-insurance-offers",
    path: "/health-insurance/offers",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/offers/index.vue")
  },
  {
    name: "health-insurance-partners-add",
    path: "/health-insurance/partners/add",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/partners/add.vue")
  },
  {
    name: "home-loans-calculators-type",
    path: "/home-loans/calculators/:type()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/calculators/[type].vue")
  },
  {
    name: "home-loans-quote-form-details",
    path: "/home-loans/quote/form/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/home-loans/quote/form/details.vue")
  },
  {
    name: "life-insurance-quote-callback",
    path: "/life-insurance/quote/callback",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/callback.vue")
  },
  {
    name: "energy-application-digital-eic",
    path: "/energy/application/digital-eic",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/application/digital-eic.vue")
  },
  {
    name: "personal-loans-quote-thank-you",
    path: "/personal-loans/quote/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/quote/thank-you.vue")
  },
  {
    name: "car-insurance-quote-form-step",
    path: "/car-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-author-author",
    path: "/expert-analysis/author/:author()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/author/[author].vue")
  },
  {
    name: "life-insurance-quote-comparison",
    path: "/life-insurance/quote/comparison",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/comparison.vue")
  },
  {
    name: "life-insurance-quote-form-step1",
    path: "/life-insurance/quote/form/step1",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/form/step1.vue")
  },
  {
    name: "car-insurance-quote-form-details",
    path: "/car-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/quote/form/details.vue")
  },
  {
    name: "car-insurance-quote-form-results",
    path: "/car-insurance/quote/form/results",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/car-insurance/quote/form/results.vue")
  },
  {
    name: "expert-analysis-category",
    path: "/expert-analysis/:category()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/[category]/index.vue")
  },
  {
    name: "health-insurance-partners-signup",
    path: "/health-insurance/partners/signup",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/partners/signup.vue")
  },
  {
    name: "health-insurance-quote-thank-you",
    path: "/health-insurance/quote/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-step",
    path: "/life-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/form/[step].vue")
  },
  {
    name: "personal-loans-quote-form-step",
    path: "/personal-loans/quote/form/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/quote/form/[step].vue")
  },
  {
    name: "expert-analysis-category-slug",
    path: "/expert-analysis/:category()/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/expert-analysis/[category]/[slug].vue")
  },
  {
    name: "health-insurance-quote-form-step0",
    path: "/health-insurance/quote/form/step0",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/form/step0.vue")
  },
  {
    name: "life-insurance-existing-customers",
    path: "/life-insurance/existing-customers",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/existing-customers.vue")
  },
  {
    name: "life-insurance-partners-thank-you",
    path: "/life-insurance/partners/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/partners/thank-you.vue")
  },
  {
    name: "life-insurance-quote-form-details",
    path: "/life-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/form/details.vue")
  },
  {
    name: "personal-loans-quote-form-details",
    path: "/personal-loans/quote/form/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/personal-loans/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-form-step",
    path: "/health-insurance/quote/form/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/form/[step].vue")
  },
  {
    name: "dashboard-vault-product-rebate",
    path: "/dashboard/vault/:product([^/]*)*/rebate",
    meta: rebatewn0hao7UdOvp4KVTeq_45ejrKZ46sy0HQ2jwPzmBgHKVgMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/rebate.vue")
  },
  {
    name: "health-insurance-application-step",
    path: "/health-insurance/application/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/[step].vue")
  },
  {
    name: "health-insurance-quote-form-details",
    path: "/health-insurance/quote/form/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/form/details.vue")
  },
  {
    name: "health-insurance-quote-policy-step0",
    path: "/health-insurance/quote/policy/step0",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/policy/step0.vue")
  },
  {
    name: "health-insurance-quote-resume",
    path: "/health-insurance/quote/resume",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/resume/index.vue")
  },
  {
    name: "life-insurance-quote-customer",
    path: "/life-insurance/quote/customer",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/customer/index.vue")
  },
  {
    name: "dashboard-vault-product-details",
    path: "/dashboard/vault/:product([^/]*)*/details",
    meta: detailsvBg6XyhFsirdfBCztlG3dRZVcikVhkWP5EQC2BOmsSYMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/details.vue")
  },
  {
    name: "buyer-protection-terms-and-conditions",
    path: "/buyer-protection/terms-and-conditions",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/buyer-protection/terms-and-conditions.vue")
  },
  {
    name: "energy-compare-by-location-location",
    path: "/energy/compare-by-location/:location()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/energy/compare-by-location/[location].vue")
  },
  {
    name: "health-insurance-quote-customer",
    path: "/health-insurance/quote/customer",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/customer/index.vue")
  },
  {
    name: "health-insurance-quote-policy-details",
    path: "/health-insurance/quote/policy/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/policy/details.vue")
  },
  {
    name: "health-insurance-quotes-results",
    path: "/health-insurance/quotes-results",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quotes-results/index.vue")
  },
  {
    name: "life-insurance-quote-customer-success",
    path: "/life-insurance/quote/customer/success",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/quote/customer/success.vue")
  },
  {
    name: "dashboard-offers-vertical-claim-offer",
    path: "/dashboard/offers/:vertical()/claim-offer",
    meta: claim_45offerCb5mSsCNSyre390gWOyLWkzCfRynO43JPUsx6UensnAMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/offers/[vertical]/claim-offer.vue")
  },
  {
    name: "dashboard-vault-product-lic-details",
    path: "/dashboard/vault/:product([^/]*)*/lic-details",
    meta: lic_45detailsvKdTSs4eGpvZ5ZtgYP8ujvJll75fuNcdC1cNlId5F_45MMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/lic-details.vue")
  },
  {
    name: "health-insurance-quote-policy-step-step",
    path: "/health-insurance/quote/policy/step/:step()",
    meta: _91step_93H43sj4ok9LTvBmqj2T6BCepVRpnpBE1j1Dv95TqyzH4Meta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/quote/policy/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc",
    path: "/health-insurance/visitors-visa-ovhc",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/index.vue")
  },
  {
    name: "preview-expert-analysis-vertical-slug",
    path: "/preview/expert-analysis/:vertical()/:slug()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/preview/expert-analysis/[vertical]/[slug].vue")
  },
  {
    name: "health-insurance-application-payment",
    path: "/health-insurance/application/payment",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/payment/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-step",
    path: "/health-insurance/visitors-visa-ovhc/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/[step].vue")
  },
  {
    name: "health-insurance-application-thankyou",
    path: "/health-insurance/application/thankyou",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/thankyou/index.vue")
  },
  {
    name: "health-insurance-rate-rise-calculator",
    path: "/health-insurance/rate-rise-calculator",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/rate-rise-calculator/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-details",
    path: "/health-insurance/visitors-visa-ovhc/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/details.vue")
  },
  {
    name: "health-insurance-application-payment-expired",
    path: "/health-insurance/application/payment/expired",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/application/payment/expired.vue")
  },
  {
    name: "life-insurance-income-protection-quote",
    path: "/life-insurance/income-protection/quote",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/income-protection/quote/index.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-thank-you",
    path: "/health-insurance/visitors-visa-ovhc/thank-you",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/thank-you.vue")
  },
  {
    name: "life-insurance-income-protection-quote-details",
    path: "/life-insurance/income-protection/quote/details",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/income-protection/quote/details.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-confirmation",
    path: "/health-insurance/visitors-visa-ovhc/confirmation",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-vertical-completion",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/completion",
    meta: completion8PqaCYIlR1H_rdeehrOgWtdxRe1EzriAYbv4xaYeKLoMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/completion.vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-quotes-results",
    path: "/health-insurance/visitors-visa-ovhc/quotes-results",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/quotes-results.vue")
  },
  {
    name: "life-insurance-income-protection-quote-confirmation",
    path: "/life-insurance/income-protection/quote/confirmation",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/life-insurance/income-protection/quote/confirmation.vue")
  },
  {
    name: "dashboard-vault-product-form-energy-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/energy/step/:step()",
    meta: _91step_932k94xRdbEdAIUKPqyNdwu8xVtcLWbriu29a5VWphDG0Meta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/energy/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-generic-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/generic/step/:step()",
    meta: _91step_93Lw7TGAqzJE7_NSlV0KQ7_45Oy_4504PKfayxEWRGBSUla7wMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/generic/step/[step].vue")
  },
  {
    name: "health-insurance-visitors-visa-ovhc-application-step",
    path: "/health-insurance/visitors-visa-ovhc/application/:step()",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/visitors-visa-ovhc/application/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-home-loan-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/home-loan/step/:step()",
    meta: _91step_93WvnB1O4xA8Oea5wk5mfVXbEveSv_7biRLBt6oNzRE94Meta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/home-loan/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-form",
    path: "/health-insurance/students-offer/:university()/form",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/students-offer/[university]/form/index.vue")
  },
  {
    name: "dashboard-vault-product-vertical-additional-details",
    path: "/dashboard/vault/:product([^/]*)*/:vertical()/additional-details",
    meta: additional_45detailsgrN2PYN6LU2P6sGtg4cN63oxH0nBooCO5ohi1UZolBAMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/[vertical]/additional-details.vue")
  },
  {
    name: "dashboard-vault-product-form-life-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/life-insurance/step/:step()",
    meta: _91step_93FvceXjKVOWouGNRpEE3j3MeKwK8XMzQsLd_45UZP2Py1kMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/life-insurance/step/[step].vue")
  },
  {
    name: "dashboard-vault-product-form-health-insurance-step-step",
    path: "/dashboard/vault/:product([^/]*)*/form/health-insurance/step/:step()",
    meta: _91step_93mHh8S6hehg_19opnfLnx5nbLAaBAfEn5l7d70wXJ_45AUMeta || {},
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/dashboard/vault/[...product]/form/health-insurance/step/[step].vue")
  },
  {
    name: "health-insurance-students-offer-university-terms-conditions",
    path: "/health-insurance/students-offer/:university()/terms-conditions",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/health-insurance/students-offer/[university]/terms-conditions/index.vue")
  },
  {
    name: "Guides",
    path: "/credit-cards/guides",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/guides.vue")
  },
  {
    name: "Companies",
    path: "/credit-cards/companies",
    component: () => import("/codebuild/output/src3273820475/src/packages/nuxt/pages/[vertical]/companies/index.vue")
  }
]